/** Map a 1-6 column count to a responsive Tailwind grid-cols class. */
const COLUMN_CLASSES: Record<number, string> = {
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-2 sm:grid-cols-3',
  4: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4',
  5: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5',
  6: 'grid-cols-3 sm:grid-cols-4 lg:grid-cols-6',
};

export function gridColumnsClass(columns: number): string {
  return COLUMN_CLASSES[columns] ?? COLUMN_CLASSES[4];
}
